/* Wires the garage into the page: the header control, the dialog, and the fit
 * check on a product page.
 *
 * Everything paints from one event. Components do not read storage for
 * themselves, they listen, which is what keeps the header and the product page
 * from ever disagreeing about which car is in the garage. */
;(function () {
  var G = window.ACGarage
  if (!G) return

  /* ---- the dialog ---------------------------------------------------- */
  var modal = document.querySelector('garage-modal')
  var lastFocus = null

  function openModal() {
    if (!modal) return
    lastFocus = document.activeElement
    modal.hidden = false
    document.documentElement.classList.add('garage-open')
    var picker = modal.querySelector('garage-picker')
    if (picker && picker.render) {
      picker.state = { model: null, year: null }
      picker.render()
    }
  }

  function closeModal() {
    if (!modal) return
    modal.hidden = true
    document.documentElement.classList.remove('garage-open')
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true })
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-garage-open]')) {
      event.preventDefault()
      openModal()
    } else if (event.target.closest('[data-garage-close]')) {
      event.preventDefault()
      closeModal()
    } else if (event.target.closest('[data-garage-back]')) {
      /* The back button sits in the dialog header, above the picker in the DOM,
         so it cannot be rendered by the element that owns the step state. It
         asks that element to step back instead of keeping a second copy of
         where we are. */
      event.preventDefault()
      var picker = modal && modal.querySelector('garage-picker')
      if (picker && picker.back) picker.back()
    } else if (event.target.closest('[data-garage-remove]')) {
      event.preventDefault()
      G.remove(event.target.closest('[data-garage-remove]').dataset.garageRemove)
    } else if (event.target.closest('[data-garage-use]')) {
      event.preventDefault()
      var row = event.target.closest('[data-garage-use]')
      var picked = G.list().filter(function (v) {
        return String(v.id) === String(row.dataset.garageUse)
      })[0]
      if (picked) {
        G.set(picked)
        closeModal()
      }
    } else if (event.target.closest('[data-garage-shop-without]')) {
      /* Browse everything without deleting the garage. The vehicles stay saved
         and the shopper can switch back to one in a tap; only the filtering
         stops, and only for this visit. */
      event.preventDefault()
      G.showAll(true)
      closeModal()
      var url = G.filterUrl(window.location.href, null)
      if (url !== window.location.pathname + window.location.search) window.location.assign(url)
      /* Nothing to navigate to on a product page, an article or an unfiltered
         collection. Without this the menu still showed "Show everything" as
         though the tap had not registered, and the shopper tapped it again. */
      else paint(G.get())
    } else if (event.target.closest('[data-garage-show-all]')) {
      /* "Show everything": remembered until the shopper asks for their car
         back, so the next collection and the next visit do not put the filter
         straight back on. One path from every entrance (the empty state, the
         listing bar): set the choice, then load the unfiltered page. */
      event.preventDefault()
      G.showAll(true)
      var all = G.filterUrl(window.location.href, null)
      if (all !== window.location.pathname + window.location.search) window.location.assign(all)
      else paint(G.get())
    } else if (event.target.closest('[data-garage-only-fits]')) {
      /* The way back: only parts for the car in the garage. */
      event.preventDefault()
      G.showAll(false)
      var mine = G.get()
      closeModal()
      /* On a listing, load it filtered. Anywhere else there is nothing to
         filter; the choice is recorded and the next listing honours it. */
      var only = mine && G.onListing() ? G.filterUrl(window.location.href, mine) : null
      if (only && only !== window.location.pathname + window.location.search) window.location.assign(only)
      else paint(mine)
    } else if (event.target.closest('[data-garage-clear]')) {
      event.preventDefault()
      G.clear()
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal()
  })

  document.addEventListener('garage:picked', closeModal)

  /* The picker is drawn from the garage, so a change to the garage while the
     dialog is open has to redraw it. Removing the last car left "Adding another
     vehicle to your garage" on screen until the shopper closed the dialog and
     opened it again, which is the site telling them something that stopped being
     true the moment they tapped. */
  document.addEventListener(G.EVENT, function () {
    if (!modal || modal.hidden) return
    var picker = modal.querySelector('garage-picker')
    if (picker && picker.render) picker.render()
  })

  /* The picker announces every step so the header's back button can appear and
     disappear with it. One owner of the state, one event. */
  document.addEventListener('garage:step', function (event) {
    if (!modal) return
    modal.querySelectorAll('[data-garage-back]').forEach(function (el) {
      el.hidden = !(event.detail && event.detail.canGoBack)
    })
  })

  /* ---- painting ------------------------------------------------------- */
  /* Every car in the garage, with the active one marked. Painted from storage
     rather than rendered in Liquid, because the page is cached and shared and
     cannot know whose garage will read it. */
  function paintList(active) {
    var host = document.querySelector('[data-garage-list]')
    if (!host) return
    var strings = document.querySelector('[data-garage-strings]')
    var t = function (key, fallback) {
      var v = strings && strings.getAttribute('data-' + key)
      return v || fallback
    }
    host.innerHTML = G.list()
      .map(function (v) {
        var on = !!active && String(v.id) === String(active.id)
        return (
          '<li class="garage-modal__row' + (on ? ' is-active' : '') + '">' +
          '<button type="button" class="garage-modal__use" data-garage-use="' + esc(v.id) + '"' +
          ' aria-current="' + (on ? 'true' : 'false') + '"' +
          ' title="' + esc(on ? t('active', 'Shopping for this') : t('switch-to', 'Shop for this vehicle')) + '">' +
          '<span class="garage-modal__row-mark"></span>' +
          '<span class="garage-modal__row-name">' + esc(v.name) + '</span>' +
          '</button>' +
          '<button type="button" class="garage-modal__row-remove" data-garage-remove="' + esc(v.id) + '"' +
          ' aria-label="' + esc(t('remove', 'Remove')) + ' ' + esc(v.name) + '">&times;</button>' +
          '</li>'
        )
      })
      .join('')
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }

  function modelName(vehicle) {
    var tree = G.tree()
    if (!vehicle || !tree) return ''
    var match = tree.models.filter(function (m) {
      return m.key === vehicle.model
    })[0]
    return match ? match.name : ''
  }

  var lastPainted = null

  function paint(vehicle) {

    document.querySelectorAll('[data-garage-vehicle]').forEach(function (el) {
      el.textContent = vehicle ? vehicle.name : ''
      el.hidden = !vehicle
    })
    /* The model on its own, for the way out of a "doesn't fit": "Shop wheels
       that fit your Mustang" reads better than repeating the whole vehicle, and
       it is the wider, more useful net.

       Derived from the tree by key rather than stored on the vehicle, so a
       garage saved before this existed still paints. */
    document.querySelectorAll('[data-garage-model]').forEach(function (el) {
      el.textContent = modelName(vehicle)
    })
    paintList(vehicle)
    document.querySelectorAll('[data-garage-current]').forEach(function (el) {
      el.hidden = !vehicle
    })
    /* "Nothing in here fits your car" is a fitment claim, so it may only be
       made when the vehicle filter is what emptied the grid. Gated on the
       garage alone, a price filter that returned nothing told a shopper with
       a Mustang that nothing in the collection fits their Mustang, which the
       catalogue never said (CLAUDE.md 7.3, 9.3), and offered them a button
       that turns the vehicle filter off site-wide to solve a price problem. */
    var fitEmptied = !!vehicle && G.isFiltered(vehicle)
    document.querySelectorAll('[data-garage-empty]').forEach(function (el) {
      el.hidden = !fitEmptied
    })
    document.querySelectorAll('[data-garage-empty-other]').forEach(function (el) {
      el.hidden = fitEmptied
    })
    /* The mirror of the above, for the places that have something to say only
       when the garage is EMPTY. Two hooks rather than one plus a class flip,
       because a block that must never flash the wrong copy is easier to reason
       about when its condition is written on it. */
    document.querySelectorAll('[data-garage-absent]').forEach(function (el) {
      el.hidden = !!vehicle
    })
    document.querySelectorAll('.garage-header').forEach(function (el) {
      el.classList.toggle('garage-header--filled', !!vehicle)
    })
    /* The garage menu reflects "showing everything" and offers the way back,
       in the listing bar's words (owner, Jam 90e55147). */
    var all = !!vehicle && G.isShowingAll()
    document.querySelectorAll('[data-garage-showing-all]').forEach(function (el) {
      el.hidden = !all
    })
    document.querySelectorAll('[data-garage-shop-without]').forEach(function (el) {
      el.hidden = all
    })

    paintFit(vehicle)
    paintCoverage(vehicle)
    rewriteLinks(vehicle)
    lastPainted = vehicle || null
  }

  /* ---- a vehicle the catalogue has nothing for -------------------------- */
  /* When zero products carry the chosen vehicle, garage.js skips the collection
     redirect (the filtered page is guaranteed empty), so the shopper is looking
     at the unfiltered collection. This paints the line that says so, because a
     filter silently not applying looks like a filter that is broken.

     The same knowledge drives [data-garage-all-fits], the "see everything that
     fits" escape route in the filtered-empty state: its href gets the vehicle
     filter, and it hides for a zero-coverage vehicle, because the page it
     offers would be empty too. */
  function paintCoverage(vehicle) {
    var zero = false
    if (vehicle && typeof G.countFor === 'function') zero = G.countFor(vehicle.id) === 0
    /* The listing bar: which view the shopper is in, with the other one a tap
       away (owner, Jam a7c9a881). Filtered when the URL carries the vehicle;
       otherwise "everything", with the way back; and the no-coverage line when
       the filter was deliberately left off because it would find nothing. */
    var state = null
    if (vehicle && G.onListing()) {
      /* Filtered ON THIS VEHICLE. A page filtered on another car (a bookmark,
         a shared link, the back button) is not "showing parts for your F-150",
         and saying so over a grid of Mustang parts would be a false statement
         about what the shopper is looking at. That case reads as everything,
         which is the honest half-truth: their filter is not applied. */
      if (G.isFiltered(vehicle)) state = 'filtered'
      else if (zero) state = 'nocoverage'
      else state = 'all'
    }
    /* The filtered-empty panel already says which vehicle and offers Show
       everything; a bar saying the same thing above it is the same button
       twice. */
    if (state === 'filtered' && document.querySelector('.garage-empty:not([hidden])')) state = null
    document.querySelectorAll('[data-garage-bar]').forEach(function (bar) {
      bar.hidden = !state
      bar.querySelectorAll('[data-garage-bar-state]').forEach(function (el) {
        el.hidden = el.dataset.garageBarState !== state
      })
    })
    document.querySelectorAll('[data-garage-all-fits]').forEach(function (a) {
      a.hidden = !vehicle || zero
      var base = a.dataset.garageHref || a.getAttribute('href')
      if (!base) return
      a.dataset.garageHref = base
      if (vehicle && !zero) a.setAttribute('href', G.filterUrl(base, vehicle))
    })
  }

  /* ---- picking a car filters the listing you are on -------------------
     Choosing a vehicle IS the request to see parts for it (owner, Jam
     4d3c7006: "default should be products that fit the car, not
     everything"). The garage used to only rewrite the links, so the shopper
     picked their car, stayed on the unfiltered collection, and had to press
     a second button to see what fits. Now the pick lands them there.

     Only from a garage change during the pageview, never from the paint on
     load: applyToCollection in garage.js already handles arriving with a car,
     from a blocking script, before anything renders. The guards are the same
     ones it uses, and for the same reasons:
     - nothing to filter off a listing page
     - already filtered on this vehicle: nothing to do
     - zero coverage store-wide: the filtered page is guaranteed empty, so
       the shopper stays on the full collection and the bar says why.
     Other filters survive, because filterUrl only touches the fitment one. */
  function filterOnPick(vehicle, announced) {
    /* The load-time announcement carries the stored vehicle and is not a
       change: acting on it sent a shopper who had just asked for everything
       straight back to the filtered page. Arriving with a car is already
       handled before render by applyToCollection in garage.js. */
    if (announced) return
    if (!vehicle || !G.onListing() || G.isShowingAll()) return
    if (G.isFiltered(vehicle)) return
    if (typeof G.countFor === 'function' && G.countFor(vehicle.id) === 0) return
    var next = G.filterUrl(window.location.href, vehicle)
    if (!next || next === window.location.pathname + window.location.search) return
    window.location.assign(next)
  }

  document.addEventListener(G.EVENT, function (event) {
    paint(event.detail)
    filterOnPick(event.detail, event.announced)
  })

  /* Paint once from storage as soon as this file runs, rather than waiting for
     the event. Script order should make the event enough, and it did not: these
     are deferred scripts, so garage.js was announcing before this file existed
     and a stored vehicle painted nothing until the shopper changed it. Reading
     once here makes the first paint independent of who loaded first. */
  paint(G.get())

  /* ---- the fit check --------------------------------------------------- */
  /* Three states, never two. See the note in garage.js: a product with no
     fitment data is NOT a product that fits everything, and rendering them the
     same way would be a claim the catalogue cannot support. */
  function paintFit(vehicle) {
    document.querySelectorAll('[data-garage-fit]').forEach(function (el) {
      var ids
      try {
        ids = JSON.parse(el.dataset.garageFit || '[]')
      } catch (e) {
        ids = []
      }
      var result = G.checkFit(
        ids.map(String), vehicle,
        el.hasAttribute('data-garage-universal'), el.hasAttribute('data-garage-trim-note')
      )
      el.classList.remove(
        'garage-fit--fits', 'garage-fit--trims', 'garage-fit--no', 'garage-fit--unknown',
        'garage-fit--universal', 'garage-fit--empty'
      )
      el.classList.add('garage-fit--' + (result || 'empty'))
      el.querySelectorAll('[data-fit-state]').forEach(function (part) {
        part.hidden = part.dataset.fitState !== (result || 'empty')
      })
    })
  }

  /* ---- content that arrives after the first paint ---------------------- */
  /* Recently Viewed, Related Products, the quick view and any filtered grid all
     inject their markup after this file has already painted, so the fit lines
     inside them were rendered and never resolved: the shopper saw nothing on a
     carousel while the same product on the page above it answered fine.

     One observer covers all of them, and every future one, which is the point:
     the alternative is a hook per section and a new bug every time a section is
     added. Repainting is idempotent, and it is coalesced into a single frame so
     a carousel injecting twenty cards costs one pass, not twenty. */
  var WATCHED = '[data-garage-fit], [data-garage-vehicle], [data-garage-current],' +
    ' [data-garage-absent], [data-garage-empty], [data-garage-empty-other], [data-garage-bar]'
  var repaintQueued = false
  new MutationObserver(function (records) {
    if (repaintQueued) return
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes
      for (var j = 0; j < added.length; j++) {
        var node = added[j]
        if (node.nodeType !== 1) continue
        if (node.matches(WATCHED) || node.querySelector(WATCHED)) {
          repaintQueued = true
          requestAnimationFrame(function () {
            repaintQueued = false
            paint(G.get())
          })
          return
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true })

  /* ---- browsing filtered ---------------------------------------------- */
  /* Collection and search links carry the vehicle, so a shopper who has told us
     what they drive keeps seeing parts for it as they move around. Deliberately
     NOT a redirect: the shopper opted in by choosing a car, and every filtered
     page keeps a visible way back to everything. */
  function rewriteLinks(vehicle) {
    /* Reversible, and always recomputed from the link's ORIGINAL href.

       It used to skip any link that already carried the filter, which made
       the rewrite one-way and broke three things at once: switching vehicles
       left every link pointing at the old car (the "shop parts that fit your
       F-150" link filtered to the Mustang), clearing the garage left the
       whole site filtered to a car the shopper had just deleted, and asking
       for everything without navigating left the links stamped, so the next
       click put the filter straight back on.

       The original is kept on the element the first time it is seen, so a
       rewrite is idempotent and can be undone. */
    var on =
      !!vehicle &&
      !G.isShowingAll() &&
      /* Zero coverage: every rewritten link would land on a guaranteed-empty
         page. Leave them alone and the no-coverage bar does the talking. */
      !(typeof G.countFor === 'function' && G.countFor(vehicle.id) === 0)
    document.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
      if (a.dataset.garageSkip === 'true') return
      /* The theme's own "remove this filter" and "clear all" links. Their whole
         job is to produce a URL WITHOUT a filter, and stamping the vehicle back
         into them made the × on the vehicle chip do nothing at all: facets.js
         reads the mutated href, so the shopper's most obvious way out of the
         filter was the one control guaranteed not to work. */
      if (a.getAttribute('is') === 'facet-remove') return
      var base = a.dataset.garageHref || a.getAttribute('href')
      if (!base || base.indexOf('/collections/') === -1) return
      /* A link to one product inside a collection is not a listing. */
      if (base.indexOf('/products/') !== -1) return
      /* Pagination: filterUrl drops the page cursor, which is right for a
         filter change and wrong here. Rewriting "2" would send the shopper
         back to page 1 under a new filter. */
      if (/[?&]page=/.test(base)) return
      a.dataset.garageHref = base
      a.setAttribute('href', on ? G.filterUrl(base, vehicle) : base)
    })
  }

  /* ---- which row is the garage on ----

     The nav control and the phone's tab are the same block wearing two shapes:
     flush in the category bar when it shares that row, a button with room
     around it when it has a row to itself. Which one it needs was decided by a
     viewport breakpoint, and that was wrong, because the header row wraps: above
     the breakpoint the garage can still be pushed onto a line of its own, and
     there it kept the category-bar shape and collapsed to a 30px strip with
     square corners (owner, 2026-09-03).

     Whether it wrapped is a fact about the layout, not about the viewport, and
     the width where it happens moves with the length of the vehicle's name. So
     it is measured. The class goes on the row, because the row's own padding
     changes too, and CSS cannot select an ancestor.

     The CSS keeps its breakpoint as the no-JS default, so nothing flashes on a
     wide screen before this runs; this only corrects the case the breakpoint
     gets wrong. */
  var STACKED = 'garage-stacked'
  var SPLIT = 'garage-split'

  /* Does the category bar have room for the garage beside it?

     Flex should decide this on its own and does not: the bar's intrinsic width
     comes out about 12px under the width of the tabs it holds, so in a narrow
     band the browser keeps both on one line and the last tab runs under the
     garage. Measured here instead, against what the tabs actually need, and the
     answer is a class the stylesheet reads.

     Measured with the class off, so the reading is of the unsplit row. Taking
     it off and putting it back inside one frame costs a layout, not a paint,
     so nothing flashes. */
  function syncNavSplit(row, garage) {
    var nav = row.querySelector('.header__navigation')
    var list = nav && nav.querySelector('.header__menu > ul')
    if (!nav || !list || getComputedStyle(nav).display === 'none') {
      row.classList.remove(SPLIT)
      return
    }
    row.classList.remove(SPLIT)
    var style = getComputedStyle(row)
    var available =
      row.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0)
    var needed = list.scrollWidth + garage.getBoundingClientRect().width
    if (needed > available) row.classList.add(SPLIT)
  }

  function syncGarageRow() {
    var row = document.querySelector('.header__bottom')
    var garage = row && row.querySelector('.garage-header--nav')
    if (!row || !garage) return
    /* Hidden (the phone's tab is showing instead): nothing to decide. */
    if (!garage.offsetParent && getComputedStyle(garage).display === 'none') {
      row.classList.remove(STACKED)
      return
    }
    var nav = row.querySelector('.header__navigation')
    var navVisible = nav && getComputedStyle(nav).display !== 'none'
    /* With no category bar beside it the garage is the row, and the row-level
       CSS already dresses it. Only the wrapped case needs correcting. */
    if (!navVisible) {
      row.classList.remove(SPLIT)
      row.classList.remove(STACKED)
      return
    }
    /* Decide the wrap before reading where things landed: this moves them. */
    syncNavSplit(row, garage)
    /* Tolerance rather than equality: sub-pixel layout puts the two tops a
       fraction apart even when they share a line. Half the garage's own height
       is comfortably below one row of separation and well above that noise. */
    var gTop = garage.getBoundingClientRect().top
    var nTop = nav.getBoundingClientRect().top
    var slack = Math.max(8, garage.getBoundingClientRect().height / 2)
    row.classList.toggle(STACKED, gTop - nTop > slack)
  }

  var syncQueued = false
  function queueSync() {
    if (syncQueued) return
    syncQueued = true
    requestAnimationFrame(function () {
      syncQueued = false
      syncGarageRow()
    })
  }

  window.addEventListener('resize', queueSync)
  /* The vehicle's name changes the control's width, which is what decides the
     wrap in the first place. */
  document.addEventListener(G.EVENT, queueSync)
  /* A late webfont re-measures every menu item, and the row can wrap or unwrap
     because of it. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueSync)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync)
  } else {
    queueSync()
  }
  window.addEventListener('load', queueSync)
})()
